import { AJAX, INITIAL_PAGE_LOAD, makeAjaxAction } from "../../../shared/make_ajax_action";

import { NEW_VALUE } from "./data_hub_search";

export { AJAX, INITIAL_PAGE_LOAD };

const makePath = (state) => `${state.navigation.path}.json`;
const getSelectValue = (state, key) => {
  return { value: Number(((state.filters[key] || {}).selectedValue || {}).value) || null };
};
const getMultiSelectValue = (state, key) => {
  return { value: ((state.filters[key] || {}).selectedValues || []).map(e => +e.value) };
};

const boolean = (state, key) => {
  return { value: state.filters[key] };
};

const filterData = (state) => {
  return {
    regulation_countries_filter: getMultiSelectValue(state, "countries"),
    regulation_parameters_filter: getMultiSelectValue(state, "parameters"),
    regulation_purpose_filter: getSelectValue(state, "purpose"),
    regulation_purposes_filter: getMultiSelectValue(state, "purposes"),
    regulation_regulations_filter: getMultiSelectValue(state, "regulations"),
    regulation_sub_purpose_filter: getSelectValue(state, "subPurpose"),
    regulation_sub_purposes_filter: getMultiSelectValue(state, "subPurposes"),
    regulation_meta_filter: { value: { tables: state.filters.tables } },
    regulation_focus_regulation_filter: { value: (state.filters.focusRegulationId || {}).id },
    regulation_focus_parameter_filter: { value: (state.filters.focusParameterId || {}).id },
    regulation_focus_country_filter: { value: (state.filters.focusCountryId || {}).id },
    regulation_name_filter: { value: state.filters.regulationName },
    search_object_id: state.dataHubSearch.current.id,
    regulation_has_numerical_standards_filter: boolean(state, "showOnlyRegulationsWithNumericalStandards"),
    regulation_mandatory_filter: boolean(state, "showOnlyMandatory"),
    regulation_current_filter: boolean(state, "showOnlyCurrent"),
    regulation_max_or_min_filter: getMultiSelectValue(state, "minMax"),
    regulation_regions_filter: getMultiSelectValue(state, "regions")
  };
};

export const dataRequestAjaxAction = (state, triggeringAction) => {
  const path = makePath(state);

  const postData = filterData(state);

  const extraActionProps = {
    triggeringType: triggeringAction.type
  };

  return makeAjaxAction(path, { search_object: postData, commit: "Search" }, extraActionProps);
};

export const savedSearchSelectedAjaxAction = (state, triggeringAction) => {
  const path = makePath(state);

  const postData = {
    // TODO(SI): change current_search_id to saved_search_id everywhere in the codebase
    saved_search_id: state.dataHubSearch.selectedSavedSearch.value,
    render_filters: 1
  };

  const extraActionProps = {
    triggeringType: triggeringAction.type
  };

  return makeAjaxAction(path, { search_object: postData, commit: "Load" }, extraActionProps);
};

export const savedSearchGetOptionsAction = (state, triggeringAction) => {
  const path = `${state.navigation.path}/saved-search-options.json`;

  const extraActionProps = {
    triggeringType: triggeringAction.type
  };

  return makeAjaxAction(path, {}, extraActionProps, "GET");
};

// eslint-disable-next-line no-unused-vars
export const savedSearchSubmitAction = (state, triggeringAction) => {
  const path = makePath(state);
  const loadedSearch = state.dataHubSearch.selectedSavedSearch;

  // TODO(SI): Basically, if we get here and the search is loaded, it means we are downloading it.
  // We should be more explicit about that.
  if (loadedSearch) {
    const savedSearchId = loadedSearch.value;

    const postData = { saved_search_id: savedSearchId };

    const extraActionProps = {
      triggeringType: triggeringAction.type
    };

    const commit = "Download loaded search";
    return makeAjaxAction(path, { search_object: postData, commit: commit }, extraActionProps);
  } else {
    const searchVal = state.savedSearches.selectedOptionValue;

    const savedSearchId = searchVal === NEW_VALUE ? null : searchVal;

    const postData = filterData(state);
    Object.assign(postData, {
      saved_search_id: savedSearchId,
      saved_search_name: state.savedSearches.textValue,
      render_search_options: 1
    });

    const extraActionProps = {
      triggeringType: triggeringAction.type
    };

    const commit = state.savedSearches.downloading ? "Download" : "Save search";
    return makeAjaxAction(path, { search_object: postData, commit: commit }, extraActionProps);
  }
};
